import { mapState } from "vuex";

import listable from "@/mixins/listable";
import calendarMarkable from '@/mixins/calendar-markable';
import calendarDraggable from '@/mixins/calendar-draggable';

import calendarConfig from "@/config/calendar";

export default {
  mixins: [
    listable,
    calendarMarkable,
    calendarDraggable
  ],
  data() {
    return {
      filters: {
        date: calendarConfig.date,
        days: calendarConfig.days,
        view: calendarConfig.view
      },
      withoutPagination: true
    }
  },
  methods: {
    next(level) {
      const date = this.$moment(this.filters.date);

      if (level === 1) {
        this.filters.date = this.$toDateString(date.add(1, 'days'));
      }
      if (level === 2) {
        this.filters.date = this.$toDateString(date.add(this.filters.days, 'days'));
      }
    },
    prev(level) {
      const date = this.$moment(this.filters.date);

      if (level === 1) {
        this.filters.date = this.$toDateString(date.add(-1, 'days'));
      }
      if (level === 2) {
        this.filters.date = this.$toDateString(date.add(-this.filters.days, 'days'));
      }
    },
    more() {
      this.getData({
        page: this.pagination.page + 1
      });
      this.request.loading = false;
    },
    dateChanged() {
      if (this.filters.days > 14) {
        this.filters.days = this.$moment(this.filters.date).daysInMonth();
      }
    },
    dayClass(day) {
      let classes = [];

      if (day.day() === 6 || day.day() === 0) {
        classes.push('is-weekend');
      }
      if (this.filters.days === 7) {
        classes.push('week-view');
      }
      if (this.filters.days === 14) {
        classes.push('two-weeks-view');
      }
      if (this.filters.days > 14) {
        classes.push('month-view');
      }
      if (day.isSame(this.$moment())) {
        classes.push('is-today');
      }

      return classes;
    },
  },
  computed: {
    pagination() {
      return this.request.data.pagination || {};
    },
    collection() {
      return this.request.data.collection || [];
    },
    moreEnabled() {
      return this.pagination.page < this.pagination.totalPages;
    },
    start() {
      return this.filters.date ? this.$moment(this.filters.date) : this.$moment();
    },
    dates() {
      let result = [];

      let end = this.$moment(this.start);
      let start = this.$moment(this.start);

      end.add(this.filters.days, 'days');

      do {
        let byYear = this.$findByAttribute(result, 'year', start.year());
        let byMonth = this.$findByAttribute(result, 'month', start.month());

        const day = this.$moment(start);

        if (!byYear || !byMonth) {
          result.push({
            year: start.year(),
            month: start.month(),
            monthName: start.locale(this.$locale()).format('MMM'),
            days: [day]
          });
        } else {
          byMonth.days.push(this.$moment(start));
        }

        start.add(1, 'days')
      } while (start.isBefore(end));

      return result;
    },
    ...mapState({
      propertyIds: state => state.settings.property.ids,
      calendarSettings: state => state.settings.calendar,
    })
  },
  watch: {
    propertyIds: {
      handler() {
        this.getData();
      },
      deep: true
    },
  }
}
